define.alias("shared/components/shared/post/secondary/activity/comment", "settings/components/shared/post/secondary/activity/comment");